function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// update ../../main/scss/vars.scss when changing this file
const fontFamily = {
  fontFamily: 'Artifakt Element, sans-serif'
};
export default {
  hero: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 400,
    fontSize: '48px',
    lineHeight: '64px'
  }),
  title: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 400,
    fontSize: '30px',
    lineHeight: '42px'
  }),
  heading1: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 400,
    fontSize: '24px',
    lineHeight: '30px'
  }),
  heading2: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 400,
    fontSize: '20px',
    lineHeight: '26px'
  }),
  heading3: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '22px'
  }),
  heading4: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '20px'
  }),
  heading5: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '16px'
  }),
  bodyLarge: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '22px'
  }),
  bodyLargeBold: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '22px'
  }),
  bodyMedium: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px'
  }),
  bodyMediumBold: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '20px'
  }),
  bodySmall: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '16px'
  }),
  bodySmallBold: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '16px'
  }),
  labelMedium: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px'
  }),
  labelSmall: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '16px'
  }),
  caption: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 500,
    fontSize: '11px',
    lineHeight: '15px'
  }),
  captionBold: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 700,
    fontSize: '11px',
    lineHeight: '15px'
  }),
  eyebrow: _objectSpread(_objectSpread({}, fontFamily), {}, {
    fontWeight: 700,
    fontSize: '10px',
    lineHeight: '15px',
    letterSpacing: 0.5,
    textTransform: 'uppercase'
  }),
  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  lineClamp: {
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden'
  }
};
//# sourceMappingURL=typography.js.map